// app/javascript/compcalc/components/ErrorHandling.jsx

import React from "react";
import { withSnackbar } from 'notistack';

let withErrorHandling = WrappedComponent => {

  let ErrorHandling = class extends React.PureComponent {
    // --------------------- Fetching ---------------------
    fetch = (url, resolve) => {
      // let snack = this.showSnackbar(fetchingMessage, 'info');
      return fetch(url).then(this.handleErrors).then(response => response.json()).then(this.responseErrorCheck).then(results => {
        console.log(url);
        resolve(results);
        // this.props.closeSnackbar(snack);
        // this.showSnackbar(successMessage, 'success');
      });
    }

    fetchPOST = (url, body, resolve, reject) => {
      // let snack = this.showSnackbar(fetchingMessage, 'info');

      // console.log(`fetchPOST: ${body}`);

      let params = { method: 'POST', body: body };
      return fetch(url, params).then(this.handleErrors).then(response => response.json()).then(this.responseErrorCheck).then(result => {
        console.log(url);
        resolve(result);
        // this.props.closeSnackbar(snack);
        // this.showSnackbar(successMessage, 'success');
      });
    }

    // --------------------- Error handling ---------------------
    handleErrors = (response) => {
      if (!response.ok || response.status != 200)
        throw new Error(`${response.statusText}: ${response.url}`);
      return response;
    }

    responseErrorCheck = (response) => {
      if (response['error'])
        throw new Error(response['error']);
      return response;
    }

    showError = (e, msg, state) => {
      console.log(e);
      if (state)
        this.setState(state);
      return this.showSnackbar(msg, 'error');
    }

    // --------------------- Snackbars ---------------------
    showSnackbar = (message, variant) => {
      // variant could be success, error, warning or info.
      return this.props.enqueueSnackbar(message, { variant });
    };

    // --------------------- Rendering ---------------------
    render() {
      // ... and renders the wrapped component with the fresh data!
      // Notice that we pass through any additional props
      return <WrappedComponent fetch={this.fetch}
                               fetchPOST={this.fetchPOST}
                               handleErrors={this.handleErrors}
                               responseErrorCheck={this.responseErrorCheck}
                               showError={this.showError}
                               {...this.props} />;
    }
  };

  return withSnackbar(ErrorHandling);
};

export default withErrorHandling;